export default "/images/d81db321c013f78494e6db9381d5919f.avif";